// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-44ee87ec]::-webkit-scrollbar{width:.5rem;height:.5rem}[data-v-44ee87ec]::-webkit-scrollbar-thumb{background:#ccc;border-radius:.375rem}[data-v-44ee87ec]::-webkit-scrollbar-track{background:#f5f5f5;border-radius:.375rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
